import { reflectKeys } from '@/app/shared/services';
import { namespacedPrefix } from '@/app/auth/shared/config';

const actionsTypes = reflectKeys(['LOGIN', 'LOGOUT', 'ME'], namespacedPrefix);

const { LOGIN, LOGOUT, ME } = actionsTypes;

export { LOGIN, LOGOUT, ME };
